module.exports = __webpack_public_path__ + "static/yoco_home-1a381a8fa1b5635c31b82a2fdc5bf239.jpg";